import { render, staticRenderFns } from "./LiefengUploadVideo.vue?vue&type=template&id=44455296&scoped=true&"
import script from "./LiefengUploadVideo.vue?vue&type=script&lang=js&"
export * from "./LiefengUploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./LiefengUploadVideo.vue?vue&type=style&index=0&id=44455296&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44455296",
  null
  
)

export default component.exports